export class ClasseProfissional {
  id: number;
  descricao: string;
  empresa: boolean;
}
